import Rails from "rails-ujs";
import Turbolinks from "turbolinks";
import RFB from "@scottjg/novnc/core/rfb";

window.Rails = Rails;
window.Turbolinks = Turbolinks;
window.RFB = RFB;
